export const getFormattedDateOfBirthValue = (value) => {
  const [month, day] = value?.split("-") ?? "";

  if (value?.length === 2 && month?.length === 2) {
    return `${value}-`;
  }

  if (value?.length === 5 && month?.length === 2 && day?.length === 2) {
    return `${value}-`;
  }

  return value;
};
